import { render, staticRenderFns } from "./DrivingLicence.vue?vue&type=template&id=03fa89f1&"
import script from "./DrivingLicence.vue?vue&type=script&lang=js&"
export * from "./DrivingLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports